import { ControllerPaletteColor } from './__palette-color';

export enum ControllerLeftNavColor {
  DefaultBg = ControllerPaletteColor.Gray100,
  ActiveFg = ControllerPaletteColor.Ngb800,
  DefaultFg = ControllerPaletteColor.Gray600,
  HoverFg = ControllerPaletteColor.Ngb800,
  DividerBg = ControllerPaletteColor.Gray300,
  ExpandCollapseButtonBg = ControllerPaletteColor.Ngb800,
  ExpandCollapseButtonFg = ControllerPaletteColor.Gray100,
}
